export function EmptyState({ icon: Icon, title, body, cta }) {
  return (
    <div data-testid="empty-state" className="rounded-2xl border border-dashed border-white/15 bg-[#0F0F0F] p-10 text-center">
      {Icon && <div className="mx-auto w-12 h-12 rounded-full bg-gold/10 border border-gold/30 grid place-items-center"><Icon className="w-5 h-5 text-gold" /></div>}
      <h2 className="mt-4 font-display text-2xl">{title}</h2>
      {body && <p className="mt-2 text-sm text-zinc-400 max-w-md mx-auto leading-relaxed">{body}</p>}
      {cta && <div className="mt-5 inline-flex">{cta}</div>}
    </div>
  );
}
export default EmptyState;
